import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ComparatifDureeVie() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  const rows = [
    { materiau: 'comparatif_row_1_materiau', prix: 'comparatif_row_1_prix', duree: 'comparatif_row_1_duree', cout: 'comparatif_row_1_cout' },
    { materiau: 'comparatif_row_2_materiau', prix: 'comparatif_row_2_prix', duree: 'comparatif_row_2_duree', cout: 'comparatif_row_2_cout' },
    { materiau: 'comparatif_row_3_materiau', prix: 'comparatif_row_3_prix', duree: 'comparatif_row_3_duree', cout: 'comparatif_row_3_cout' },
    { materiau: 'comparatif_row_4_materiau', prix: 'comparatif_row_4_prix', duree: 'comparatif_row_4_duree', cout: 'comparatif_row_4_cout' },
    { materiau: 'comparatif_row_5_materiau', prix: 'comparatif_row_5_prix', duree: 'comparatif_row_5_duree', cout: 'comparatif_row_5_cout' },
  ];

  return (
    <section ref={ref} id="comparatif" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-4 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('comparatif_h2')}
      </h2>
      <p className={`text-slate-primary/60 text-sm md:text-base mb-6 transition-all duration-1000 delay-100 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}>{t('comparatif_intro')}</p>

      <div className={`overflow-x-auto transition-all duration-1000 delay-200 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-primary text-white">
              <th className="px-4 py-3 text-sm font-semibold rounded-tl-lg">{t('comparatif_th_materiau')}</th>
              <th className="px-4 py-3 text-sm font-semibold">{t('comparatif_th_prix')}</th>
              <th className="px-4 py-3 text-sm font-semibold">{t('comparatif_th_duree')}</th>
              <th className="px-4 py-3 text-sm font-semibold rounded-tr-lg">{t('comparatif_th_cout')}</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {rows.map((row, idx) => (
              <tr key={idx} className={`border-b border-soft-gray ${idx % 2 === 1 ? 'bg-soft-gray/30' : ''}`}>
                <td className="px-4 py-3.5 text-sm text-slate-primary font-medium">{t(row.materiau)}</td>
                <td className="px-4 py-3.5 text-sm text-slate-primary/70">{t(row.prix)}</td>
                <td className="px-4 py-3.5 text-sm text-slate-primary/70">{t(row.duree)}</td>
                <td className="px-4 py-3.5 text-sm text-copper font-bold">{t(row.cout)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className={`text-xs text-slate-primary/40 mt-3 italic transition-all duration-1000 delay-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}>{t('comparatif_note')}</p>
    </section>
  );
}